const DEXIT_COMPANY_ID = 2;

export function isDexit() {
  try {
    const raw = localStorage.getItem('companyBrand');
    if (!raw) {
      return false;
    }
    const brand = JSON.parse(raw);
    return brand?.id === DEXIT_COMPANY_ID;
  } catch {
    return false;
  }
}

export function getNavbarLogoUrl() {
  if (isDexit()) {
    return '/logo_white.png';
  }

  try {
    const raw = localStorage.getItem('companyBrand');
    if (raw) {
      const brand = JSON.parse(raw);
      if (brand?.logo) {
        const apiBase = process.env.REACT_APP_API_BASE_URL || '';
        const baseUrl = apiBase.replace(/\/api$/, '');
        return `${baseUrl}/uploads/company_logos/${brand.logo}`;
      }
    }
  } catch { /* ignore */ }

  return null;
}

export function getBrandDisplayName() {
  if (isDexit()) {
    return 'AutoHolding';
  }

  try {
    const raw = localStorage.getItem('companyBrand');
    if (raw) {
      const brand = JSON.parse(raw);
      return brand?.short_name || brand?.name || 'Interstrip';
    }
  } catch { /* ignore */ }

  return 'Interstrip';
}

export function applyBrandAssets() {
  const dexitMode = isDexit();

  const faviconLink = document.querySelector('link[rel="icon"]');
  if (faviconLink) {
    faviconLink.href = dexitMode ? '/logo_white.png' : '/favicon.png';
  }

  const appleTouchIcons = document.querySelectorAll(
    'link[rel="apple-touch-icon"]'
  );
  appleTouchIcons.forEach((link) => {
    link.href = dexitMode ? '/logo_white_192.png' : '/logo192.png';
  });

  const manifestLink = document.querySelector('link[rel="manifest"]');
  if (manifestLink) {
    manifestLink.href = dexitMode
      ? '/manifest_dexit.json'
      : '/manifest.json';
  }
}
